const MenuOverlay = ({
    accountId, sourceId, retailerId, placementId
}) => {
    return (
        <div className='surfside-menu-banner'>
            <surf-banner
                className='surf-ad-placement'
                account-id={accountId}
                channel-id="bf9bc"
                site-id={sourceId}
                placement-id={placementId}
                location-id={retailerId}
                keywords='menu,overlay'
                zone='menu,overlay'
                type='inline'
                adtypes='0,1'
                width={2}
                height={1}
            ></surf-banner>
        </div>
    );
};

export default MenuOverlay;
